import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import {
  Box,
  BoxProps,
  Grid,
  GridProps,
  Stack,
  Typography,
} from '@mui/material';
import { TP_COLORS } from '../../../constants';
import { isMobileScreen } from '../../../helper';
import { useAppSelector } from '../../../hooks';
import { getConfigState } from '../../../store/ConfigSlice';

const boxStyles: BoxProps['sx'] = {
  height: { md: '80%', lg: '80%' },
  maxWidth: { xs: '100%', sm: '90%', md: '90%', lg: '95%' },
  maxHeight: { xs: '550px', sm: '270px', md: '270px', lg: '270px' },
  color: TP_COLORS.white,
  borderRadius: '20px',
  background: TP_COLORS.blue.dark,
  marginTop: { xs: '30px', sm: '70px' },
};

const gridStyles: GridProps['sx'] = {
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  bottom: { xs: '40px', sm: '50px', md: '40px', lg: '50px' },
  left: { xs: '-5px', sm: '30px', md: '10px', lg: '20px' },
};

const reviews = [
  {
    title: 'IB Diploma Score 45/45',
    description:
      'Tutopiya was actually a great platform especially for kids like me who have transport issues and prefer it online. Not just that they have absolutely great teachers and I recommend it to anyone who needs tuition',
    name: 'Aditya Sil Student',
    image: `${process.env.PUBLIC_URL}/images/landingPage/testimonial-1.avif`,
  },
  {
    title: 'IGSCE 9As',
    description:
      'Learn with the best private tutors. Tutor Omar and Jasmine have been a great help for my son. Tutopiya has been a great support system and backbone for my son’s studies. Tutopiya’s service is very personalized and appreciated.',
    name: 'Aditya Agarwal Student',
    image: `${process.env.PUBLIC_URL}/images/landingPage/testimonial-2.avif`,
  },
  {
    title: 'IB Diploma Score 45/45',
    description:
      'Tutopiya’s management and support team are very hardworking. They have a good communication system and resolve issues easily. The question banks and resources provide help in aiding the students to excel in their respective subjects. ',
    name: 'Atriya Datta Student',
    image: `${process.env.PUBLIC_URL}/images/landingPage/testimonial-3.avif`,
  },
];

const ReviewCarousel: React.FC = () => {
  // Store
  const configState = useAppSelector(getConfigState);

  const { fromIGCSEBuddy } = configState;

  const isMobile = isMobileScreen();

  const settings = {
    arrows: false,
    autoplay: true,
    dots: true,
    autoplaySpeed: 4000,
    speed: 500,
  };

  return (
    <Slider {...settings}>
      {reviews
        .filter((item, index) => {
          if (index === 1 && fromIGCSEBuddy) {
            return false;
          }

          return true;
        })
        .map((review, index) => (
          <Box key={index} sx={boxStyles}>
            <Grid container>
              <Grid item xs={12} sm={7} md={7} lg={7}>
                <Stack padding={isMobile ? '20px' : '30px 0px 30px 30px'}>
                  <Typography variant="h5" fontWeight="600" marginBottom="10px">
                    {review.title}
                  </Typography>
                  <Typography marginBottom="10px">
                    {review.description}
                  </Typography>
                  <Typography>{review.name}</Typography>
                </Stack>
              </Grid>
              <Grid item xs={12} sm={5} md={5} lg={5} sx={gridStyles}>
                <img
                  src={review.image}
                  alt="testimonial"
                  style={{
                    width: '300px',
                    height: '336px',
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        ))}
    </Slider>
  );
};

export default ReviewCarousel;
